export default class DynatraceService {
    public static appendDynatraceScript(): void {
        const hasScript: boolean = document.getElementById('dynatrace-script') != null;
        if (hasScript) return; // return if script already exists

        const srcLoc: string = process.env.REACT_APP_DYNATRACE_SRC;
        if (!srcLoc) return; // return if env var is not set

        const script = document.createElement('script');
        script.src = srcLoc;
        script.async = true;
        script.id = 'dynatrace-script';
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
    }
}
